import classNames from 'classnames';
import moment from 'moment';
import formatDate from '../../../../../../app/frontend/components/components/utils/formatDate';
import React, { useCallback, useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const timelinesNames = [
  'hiring',
  'submit_content_draft',
  'brand_feedback',
  'posting_window'
];

function Timeline({ offer }) {
  const { timelines = {} } = offer;
  const { t } = useTranslation();
  const [state, setState] = useState({
    activeTimeline: null
  });

  useEffect(() => {
    let { activeTimeline } = state;
    timelinesNames.forEach(name => {
      const timeline = timelines[name];
      if (timeline) {
        const active = timelines[activeTimeline];
        if (!active) {
          activeTimeline = name;
          return;
        }

        if (typeof timeline === 'string') {
          if (typeof active == 'string' && moment(active).isBefore(moment(timeline))) {
            activeTimeline = name;
          } else if (moment(timeline).isBefore(moment(active.end))) {
            activeTimeline = name;
          }
        } else if (typeof active == 'string' && moment(timeline.end).isBefore(moment(active))) {
          activeTimeline = name;
        } else if (moment().isBetween(timeline.start, timeline.end)) {
          activeTimeline = name;
        }
      }
    });
    setState({
      ...state,
      activeTimeline
    });

  }, []);

  const renderTimeline = useCallback((timelineTitle, timeline, eventName) => {
    let content = null;

    if (typeof timeline === 'string') {
      content = formatDate(timeline);
    } else if (timeline.start || timeline.end) {
      content = <React.Fragment>
        {timeline.start && formatDate(timeline.start)}
        {timeline.start && timeline.end ? ' - ' : null}
        {timeline.end && formatDate(timeline.end)}
      </React.Fragment>;
    }

    if (!content) return null;

    return <div className={classNames('event', { active: state.activeTimeline === eventName })}>
      {state.activeTimeline === eventName && <div className="caret"></div>}
      <div className="text-3">
        {content}
      </div>
      <h6 className="mb-3">
        {timelineTitle}
      </h6>
    </div>;
  }, [state]);

  const timelineHasValues = (timeline) => {
    if (timeline === null || timeline === undefined) return false;
    
    if (timeline && Object.keys(timeline).length > 0) {
      Object.keys(timeline).some(k => timeline[k] != null);
    }
    
    return true;
  };

  return !timelineHasValues(timelines) ? null : <Card className="timeline">
    <Card.Header>
      <h4 className="card-header-title">
        {t('influencers.pages.campaign.timeline')}
      </h4>
    </Card.Header>
    <Card.Body>

      {timelines.hiring
        ? renderTimeline(t('influencers.pages.campaign.timelines.hiring'), timelines.hiring, timelinesNames[0]) :
        null}
      {timelines.submit_content_draft && timelines.submit_content_draft.end
        ? renderTimeline(t('influencers.pages.campaign.timelines.content_submission'), timelines.submit_content_draft, timelinesNames[1])
        : null}
      {timelines.brand_feedback
        ? renderTimeline(t('influencers.pages.campaign.timelines.brand_feedback'), timelines.brand_feedback, timelinesNames[2])
        : null}
      {
        (!offer.is_survey && timelines.posting_window)
          ? renderTimeline(t('influencers.pages.campaign.timelines.posting_window'), timelines.posting_window, timelinesNames[3])
          : null
      }
    </Card.Body>
  </Card>;
}

export default Timeline;
